import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "b6998uUQ89BNaM4ew4AaxTK", "AdXiaoXiong", undefined);

import AdEvent from "../AdEvent";
import { E_ADEventType } from "../../EnumBase";
import { _decorator, log } from "cc";
var ccclass = _decorator.ccclass;

var AdXiaoXiong = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function AdXiaoXiong() {
    _defineProperty(this, "_interstitialLoadTimes", 0);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "_videoLoadTimes", 0);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_bannerLoadTimes", 0);

    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "isBannering", false);
  }

  var _proto = AdXiaoXiong.prototype;

  _proto.init = function init() {
    var _this = this;

    if (window["JsBridge"]) {
      setTimeout(function () {
        _this.createInterstitialAd();
      }, 10);
      setTimeout(function () {
        _this.createRewardedVideoAd();
      }, 20);
    }
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {
    var _this2 = this;

    if (this._bannerLoadTimes > 1) {
      this._bannerLoadTimes++;
      return;
    }

    this._bannerLoadTimes = 1;
    window["JsBridge"].callMethod('JsInvokeJavaScope', 'loadBanner', null, function (res) {
      AdEvent.I.handleEvent(E_ADEventType.log, "createBannerAd" + JSON.stringify(res));
      _this2._bannerLoadTimes = 0;

      if (res.status.code == 0) {
        _this2.bannerLoaded = true;
        AdEvent.I.handleEvent(E_ADEventType.banner_loadOver);
      } else {
        AdEvent.I.handleEvent(E_ADEventType.banner_loadFail);
      }
    });
    AdEvent.I.handleEvent(E_ADEventType.log, "this._banner 游戏创建广告");
  };

  _proto.showBannerAd = function showBannerAd() {
    if (this.bannerLoaded) {
      //Object.keys(this._banner).length &&
      if (!window["JsBridge"]) return;
      log(".......showBannerAd");
      window["JsBridge"].callMethod('JsInvokeJavaScope', 'showBanner', null, function (res) {
        AdEvent.I.handleEvent(E_ADEventType.log, "showBannerAd" + JSON.stringify(res));
      });
    } else {
      AdEvent.I.handleEvent(E_ADEventType.log, "banner 未加载成功");
    }
  };

  _proto.hideBannerAd = function hideBannerAd() {} // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {
    var _this3 = this;

    if (this._interstitialLoadTimes > 1) {
      this._interstitialLoadTimes++;
      return;
    }

    this.interstitialAdLoaded = false;
    this._interstitialLoadTimes = 1;
    window["JsBridge"].callMethod('JsInvokeJavaScope', 'loadInterstitial', null, function (res) {
      AdEvent.I.handleEvent(E_ADEventType.log, "createInterstitialAd" + JSON.stringify(res));
      _this3._interstitialLoadTimes = 0;

      if (res.status.code == 0) {
        _this3.interstitialAdLoaded = true;
        AdEvent.I.handleEvent(E_ADEventType.interstitial_loadOver);
      } else {
        AdEvent.I.handleEvent(E_ADEventType.interstitial_loadFail);
      }
    });
    AdEvent.I.handleEvent(E_ADEventType.log, "interstitialAd 游戏创建插屏广告");
  };

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (this.interstitialAdLoaded) {
      if (!window["JsBridge"]) return;
      window["JsBridge"].callMethod('JsInvokeJavaScope', 'showInterstitial', null, function (res) {
        AdEvent.I.handleEvent(E_ADEventType.log, "showInterstitialAd" + JSON.stringify(res));
        AdEvent.I.handleEvent(E_ADEventType.interstitial_showOver);
      });
      AdEvent.I.handleEvent(E_ADEventType.log, "interstitialAd 请求展示插屏广告");
    } else {
      AdEvent.I.handleEvent(E_ADEventType.log, "interstitialAd 未加载");
      AdEvent.I.handleEvent(E_ADEventType.interstitial_showFail);
    }
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {
    var _this4 = this;

    if (this._videoLoadTimes > 1) {
      this._videoLoadTimes++;
      return;
    }

    this.videoAdLoaded = false;
    window["JsBridge"].callMethod('JsInvokeJavaScope', 'loadReward', null, function (res) {
      _this4._videoLoadTimes = 0;
      AdEvent.I.handleEvent(E_ADEventType.log, "createRewardedVideoAd" + JSON.stringify(res));

      if (res.status.code == 0) {
        _this4.videoAdLoaded = true;
        AdEvent.I.handleEvent(E_ADEventType.video_loadOver);
      } else {
        AdEvent.I.handleEvent(E_ADEventType.video_loadFail);
      }
    });
    AdEvent.I.handleEvent(E_ADEventType.log, "rewardedvideoAd 请求创建视频广告");
  };

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (this.videoAdLoaded) {
      if (!window["JsBridge"]) return;
      window["JsBridge"].callMethod('JsInvokeJavaScope', 'showReward', null, function (res) {
        AdEvent.I.handleEvent(E_ADEventType.log, "showRewardedVideoAd" + JSON.stringify(res));

        if (res.status.msg == "onRewardSuccess") {
          AdEvent.I.handleEvent(E_ADEventType.video_showOver);
        } else if (res.status.msg == "onRewardedFail") {
          AdEvent.I.handleEvent(E_ADEventType.video_showFail);
        }
      });
      AdEvent.I.handleEvent(E_ADEventType.log, "rewardedvideoAd 游戏展示视频广告");
    } else {
      AdEvent.I.handleEvent(E_ADEventType.log, "rewardedvideoAd 视频广告未加载成功");
      AdEvent.I.handleEvent(E_ADEventType.video_showFail);
    }
  };

  return AdXiaoXiong;
}(), _temp)) || _class;

export { AdXiaoXiong as default };

_cclegacy._RF.pop();